module.exports = __webpack_public_path__ + "img/add_1.115ab13e.png";